import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** A status pill matching the lifecycle pills on the design canvas
 * (docs/architecture/37 § "Status pills"). `color` is a hex the admin
 * chose for a lead status, deal stage, etc. — soft background, strong text,
 * always paired for 4.5:1 contrast at the swatch step in the admin UI. */
export function Pill({ label, color = '#454A54' }) {
    return (_jsxs("span", { className: "inline-flex h-6 items-center gap-1.5 rounded-full px-2.5 text-xs font-semibold", style: { backgroundColor: `${color}1A`, color }, children: [_jsx("span", { className: "size-1.5 rounded-full", style: { backgroundColor: color } }), label] }));
}
//# sourceMappingURL=Pill.js.map